import React, { useState } from "react";
import { Grid, Stack } from "@mui/material";
import { useStyles } from "./styles";
import Attendance from "./Attendance";
import Marks from "./Marks";
import UnstyledTabsCustomized from "../../../components/Tabs";
const TABDATA = [
  {
    label: "Marks",
    value: "marks",
  },
  {
    label: "Attendance",
    value: "attendance",
  },
];
const Historical = () => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState("attendance");
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <>
      <Grid container>
        <Grid item lg={10} sm={12} sx={{}}>
          <Stack
            sx={{
              alignItems: "center",
            }}
          >
            <UnstyledTabsCustomized
              value={activeTab}
              onChange={handleChange}
              data={TABDATA}
              defaultValue={"attendance"}
            ></UnstyledTabsCustomized>
          </Stack>
        </Grid>
      </Grid>
      {activeTab === "attendance" && <Attendance></Attendance>}
      {activeTab === "marks" && <Marks></Marks>}
    </>
  );
};

export default Historical;
